<template>
    <div>
        <div>
            <v-text-field
                hide-details
                class         = "mt-0 pt-5 mb-3"
                @input        = "onInput"
                v-model       = "sitesearch"
                :disabled     = "!customer"
                :append-icon  = "fullsearch ? 'fas fa-search-plus' : 'fas fa-search'"
                :label        = "fullsearch ? 'Volltextsuche' : 'Fabrik-Nr.'"
                @click:append ="fullsearch=!fullsearch"

                autocomplete="off"
                autocorrect="off"
                autocapitalize="off"
                spellcheck="false"
            />
        </div>

        <v-container
            class="site-seletable-content pa-0"
        >
            <v-card
                class="dragable-card"
                v-for="(item,index) in selectable"
                :key="index"
                @click="onSite(item)"
                flat
            >
                <div class="v-flex primary--text" style="justify-content: space-between">
                    <div>Fabrik-Nr. {{ item.fabricNo }}</div>
                    <div>{{ item.customer.name }}</div>
                </div>
                <!--
                <div class="card-subtitle ">{{ item.type.name }}</div>
                -->
                <div class="card-subtitle">{{ item.street }}, {{ item.zip }} {{ item.city }}</div>
            </v-card>
        </v-container>
    </div>
</template>

<script>

import Site from "@/modules/msd/unit/service/Site";

export default {
    name: "CSiteSelectSingle",

    props: {
        customer: {
            required: false,
            type    : Object,
            default : function () {
                return null;
            }
        },

        allUnits: {
            required: false,
            type    : Boolean,
            default : function () {
                return false;
            }
        },

        cardstyle: {
            required: false,
            type    : Boolean,
            default : function () {
                return false;
            }
        },

        maxHeight: {
            required: false,
            type    : Number,
            default : function () {
                return null;
            }
        },
    },

    data: () => ({
        edit      : false,
        sitesearch: "",
        selectable: [],
        height    : null,
        fullsearch: false,
    }),

    watch: {
        customer () {
            this.sitesearch = null;
            this.selectable = [];
        }
    },

    methods: {
        onInput () {
            this.$emit("search");
            if (this.sitesearch.length === 0) {
                this.selectable = [];
                return;
            }

            if (this.fullsearch) {
                this.searchFull(this.sitesearch);
            } else {
                this.search(this.sitesearch)
            }
        },

        onSite (site) {
            this.sitesearch = site.fabricNo;
            this.search(this.sitesearch)
            this.$emit("site", site)
        },

        search (value) {
            const filter = this.allUnits ? {
                onlyLiftmanagement: false,
                onlyMyCustomers   : false
                } : null;

            Site.search(this.customer.id, value, false, filter).then((data) => {
                this.selectable = data;
            });
        },

        searchFull (value) {
            const filter = this.allUnits ? {
                onlyLiftmanagement: false,
                onlyMyCustomers   : false
            } : null;

            Site.search(this.customer.id, value, true, filter).then((data) => {
                this.selectable = data;
            });
        },
    }
}
</script>

<style scoped>

.dragable-card {
    border-style: solid;
    border-width: 1px;
    border-color: lightgrey!important;
    padding: 10px;
    margin-bottom: 15px;
    border-radius: 5px;
    background-color: white;
}

.site-seletable-content {
    min-height: 310px;
    max-height: 310px;
    overflow-y: scroll;
    margin-right: 5px;
    width: calc(100% + 10px);
}

</style>